const useGTM = {
  pushEvent: (event) => {
    if (window?.dataLayer) {
      window.dataLayer.push(event);
    }
  },
};

export default useGTM;
